export default __webpack_public_path__ + "static/media/add.17550823.svg";